import type * as React from 'react';

import { css, html } from 'react-strict-dom';
import { Text } from 'src/components';

type Props = {
  children: React.ReactNode;
};

export default function SectionMessage({ children }: Props) {
  return (
    <html.div style={styles.message}>
      <Text typeface="body.regular" color="neutral60">
        {children}
      </Text>
    </html.div>
  );
}

const styles = css.create({
  message: {
    paddingBlock: 16,
  },
});
